import { render, staticRenderFns } from "./dn-cookiebar.vue?vue&type=template&id=625dd643"
import script from "./dn-cookiebar.vue?vue&type=script&lang=js"
export * from "./dn-cookiebar.vue?vue&type=script&lang=js"
import style0 from "./dn-cookiebar.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports